<template lang="html">
  <div class="pt-3 apartments-page">
    <div class="d-flex">
      <h3>Помещения</h3>

      <div class="mx-auto d-flex">
        <div class="w-300-px mr-3">
          <v-select
            placeholder="Группа"
            v-model="$store.state.apartments_filter.group_id"
            :options="$store.state.groups"
            :reduce="group => group.id"
            :getOptionLabel="group => group.name"
            @input="$store.dispatch('getManageApartments')">
          </v-select>
        </div>
        <div class="w-300-px mr-3">
          <v-select
            placeholder="Объект"
            v-model="$store.state.apartments_filter.object_id"
            :options="filterObjects"
            :reduce="object => object.id"
            :getOptionLabel="object => `${object.group_name}, ${object.name}`"
            @input="$store.dispatch('getManageApartments')">
          </v-select>
        </div>
        <div class="w-200-px mr-3">
          <v-select
            placeholder="Тип"
            v-model="$store.state.apartments_filter.apartment_type"
            :options="['residential', 'commercial']"
            @input="$store.dispatch('getManageApartments')">
          </v-select>
        </div>

        <!-- <b-form-input
          v-model="$store.state.apartments_filter.apartment_number_from"
          placeholder="Enter your name">
        </b-form-input> -->

      </div>

      <div class="">
        <button class="btn btn-light"
          @click="$store.commit('setData', {attr: 'apartment', value: {}}); $bvModal.show('itemModal')">
          Добавить
        </button>
      </div>
    </div>
    <b-table
      head-variant="light"
      small
      responsive
      bordered
      :fields="fields"
      :items="$store.state.apartments">
      <template #head(group_name)>
        <Th name="Группа" field="group_name" sort-namespace="apartments_filter" @sort-change="requestData" />
      </template>
      <template #head(group_name_ua)>
        <Th name="Группа, укр" field="group_name_ua" sort-namespace="apartments_filter" @sort-change="requestData" />
      </template>
      <template #head(object_name)>
        <Th name="Объект" field="object_name" sort-namespace="apartments_filter" @sort-change="requestData" />
      </template>
      <template #head(object_name_ua)>
        <Th name="Объект, укр" field="object_name_ua" sort-namespace="apartments_filter" @sort-change="requestData" />
      </template>
      <template #head(apartment_number)>
        <Th name="Номер" field="apartment_number" sort-namespace="apartments_filter" @sort-change="requestData" />
      </template>
      <template #head(apartment_number_ua)>
        <Th name="Номер, укр" field="apartment_number_ua" sort-namespace="apartments_filter" @sort-change="requestData" />
      </template>
      <template #head(apartment_type)>
        <Th name="Тип" field="apartment_type" sort-namespace="apartments_filter" @sort-change="requestData" />
      </template>
      <template #head(common_square)>
        <Th name="Площадь" field="common_square" sort-namespace="apartments_filter" @sort-change="requestData" />
      </template>
      <template #head(heating_square)>
        <Th name="Площадь отапливаемая" field="heating_square" sort-namespace="apartments_filter" @sort-change="requestData" />
      </template>
      <template #cell(btn)="data">
        <b-button
          variant="light"
          @click="$store.commit('setData', {attr: 'apartment', value: data.item}); $bvModal.show('itemModal')">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info" viewBox="0 0 16 16">
            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
          </svg>
        </b-button>
        <button
          class="btn btn-light"
          @click="$store.commit('setData', {attr: 'apartment', value: data.item}); $store.dispatch('deleteApartment')">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
            <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
          </svg>
        </button>
      </template>
    </b-table>

    <b-pagination
      v-model="$store.state.apartments_filter.page"
      :total-rows="$store.state.total_apartments"
      :per-page="50"
      @page-click="pageClick">
    </b-pagination>

    <b-modal id="itemModal" hide-footer title="Помещение" @show="onModalShow">
      <form ref="form" @submit.stop.prevent="$store.dispatch('saveApartment')">

        <b-form-group
          label="Аккаунт"
          label-for="user_id-select">
          <b-form-select
            v-model="$store.state.apartment.user_id"
            :options="$store.state.customers.map(c => {return {value: c.user.id, text: `${c.user.first_name} ${c.user.last_name}`}})">
          </b-form-select>
        </b-form-group>

        <b-form-group
          label="Группа"
          label-for="group-select">
          <b-form-select
            id="group-select"
            v-model="modalGroupId"
            :options="$store.state.groups.map(g => ({value: g.id, text: g.name}))">
          </b-form-select>
        </b-form-group>

        <b-form-group
          label="Объект"
          label-for="object-select"
          invalid-feedback="Объект - обязательное поле">
          <b-form-select
            required
            v-model="$store.state.apartment.object_id"
            :options="modalObjects.map(o => {return {value: o.id, text: `${o.group_name} ${o.name}`}})">
          </b-form-select>
        </b-form-group>

        <b-form-group
          label="Номер помещения"
          label-for="apartment_number-input"
          invalid-feedback="Номер обязательно">
          <b-form-input
            id="apartment_number-input"
            v-model="$store.state.apartment.apartment_number"
            required>
          </b-form-input>
        </b-form-group>

        <b-form-group
          label="Номер помещения, укр"
          label-for="apartment_number_ua-input"
          invalid-feedback="Номер обязательно">
          <b-form-input
            id="apartment_number_ua-input"
            v-model="$store.state.apartment.apartment_number_ua"
            required>
          </b-form-input>
        </b-form-group>

        <b-form-group
          label="Тип"
          label-for="apartment_type-select"
          invalid-feedback="Тип - обязательное поле">
          <b-form-select
            required
            v-model="$store.state.apartment.apartment_type"
            :options="['residential', 'commercial']">
          </b-form-select>
        </b-form-group>

        <b-form-group
          label="Жилая площадь"
          label-for="common_square-input">
          <b-form-input
            id="common_square-input"
            number
            v-model="$store.state.apartment.common_square">
          </b-form-input>
        </b-form-group>

        <b-form-group
          label="Отапливаемая площадь"
          label-for="heating_square-input">
          <b-form-input
            id="heating_square-input"
            number
            v-model="$store.state.apartment.heating_square">
          </b-form-input>
        </b-form-group>

        <button type="submit" class="btn btn-primary">Сохранить</button>
      </form>
    </b-modal>

  </div>
</template>

<script>
import Th from './Th'
export default {
  name: 'ManageObjects',
  components: {
    Th
  },
  data: () => {
    return {
      fields: [
        {label: 'Группа', key: 'group_name', sortable: true},
        {label: 'Группа, укр', key: 'group_name_ua', sortable: true},
        {label: 'Объект', key: 'object_name', sortable: true},
        {label: 'Объект, укр', key: 'object_name_ua', sortable: true},
        {label: 'Номер', key: 'apartment_number', sortable: true},
        {label: 'Номер, укр', key: 'apartment_number_ua', sortable: true},
        {label: 'Тип', key: 'apartment_type', sortable: true},
        {label: 'Площадь', key: 'common_square', sortable: true},
        {label: 'Площадь отапливаемая', key: 'heating_square', sortable: true},
        {label: '', key: 'btn', th_class: 'text-right'},
      ],
      modalGroupId: null,
    }
  },
  computed: {
    filterObjects () {
      if (this.$store.state.apartments_filter.group_id) {
        return this.$store.state.objects.filter(o => o.group_id === this.$store.state.apartments_filter.group_id)
      }
      return this.$store.state.objects
    },
    modalObjects () {
      if (this.modalGroupId) {
        return this.$store.state.objects.filter(o => o.group_id === this.modalGroupId)
      }
      return this.$store.state.objects
    }
  },
  methods: {
    pageClick () {
      setTimeout(() => {
        this.$store.dispatch('getManageApartments')
      }, 100)
    },
    requestData () {
      this.$store.dispatch('getManageApartments')
    },
    onModalShow () {
      const currentGroup = this.$store.state.apartment.group_id
      const resolvedGroup = this.resolveGroupIdByObjectId(this.$store.state.apartment.object_id)
      this.modalGroupId = currentGroup || resolvedGroup || null
    },
    resolveGroupIdByObjectId (objectId) {
      const selectedObject = this.$store.state.objects.find(o => o.id === objectId)
      return selectedObject ? selectedObject.group_id : null
    },
  },
  watch: {
    '$store.state.apartment.object_id': {
      handler (val) {
        if (val) {
          const groupId = this.resolveGroupIdByObjectId(val)
          if (groupId && groupId !== this.modalGroupId) {
            this.modalGroupId = groupId
          }
        }
      }
    },
    modalGroupId (newVal) {
      const objectId = this.$store.state.apartment.object_id
      if (!objectId || !newVal) {
        return
      }
      const selectedObject = this.$store.state.objects.find(o => o.id === objectId)
      if (selectedObject && selectedObject.group_id !== newVal) {
        this.$store.commit('setData', {
          attr: 'apartment',
          value: {...this.$store.state.apartment, object_id: null}
        })
      }
    }
  },
  mounted () {
    const apartments_filter = {
      page: 1,
      apartment_type: null,
      group_id: null,
      object_id: null,
    }
    this.$store.commit('setData', {attr: 'apartments_filter', value: apartments_filter})
    this.$store.dispatch('getManageApartments')
  }
}
</script>

<style lang="css">
/* Стили для селектов: опции переносятся на новую строку */
.apartments-page .v-select .vs__dropdown-option {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  line-height: 1.4;
  padding: 8px 12px;
}

.apartments-page .v-select .vs__dropdown-menu {
  max-width: 100%;
}

.apartments-page .v-select .vs__selected-options {
  flex-wrap: wrap;
}

.apartments-page .v-select .vs__selected {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
